import React, { useEffect } from "react";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { DEFAULT_FOOD_TYPES } from "./types/configuration.types";
import { ToastContainer, toast } from "react-toastify";
import { PageTitle } from "../PageTitle";

const FoodTypesTab = () => {
  const { user, foodTypes, newType, setNewType, removeFoodType, saveFoodTypes } = useConfigurationState();

  // ✅ Handle Add & Save
  const handleAddAndSave = () => {
    const trimmed = newType.trim();

    if (!trimmed) return;

    // prevent duplicate
    if (foodTypes.includes(trimmed)) {
      toast.error("Food type already exists");
      return;
    }

    // max limit check
    if (foodTypes.length >= 5) {
      toast.error("Maximum 5 food types allowed");
      return;
    }

    const updatedFoodTypes = [...foodTypes, trimmed];

    saveFoodTypes({ foodTypes: updatedFoodTypes });

    setNewType(""); // clear input
  };

  useEffect(() => {
    if (user?.business_type !== "Grocery") {
      document.title = "Food Types › Configuration › iMetanic";
    }
  }, []);

  return (
    <div className='w-full min-h-screen bg-gray-50'>
      <PageTitle title=' - Configuration ›  Food Types' />
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6'>
        {user?.business_type !== "Restaurant" ? (
          <div className='w-full border p-8 rounded-xl shadow bg-white text-center'>
            <p className='text-gray-500'>Food Types settings are only available for Restaurant business type.</p>
          </div>
        ) : (
          <div className='w-full border p-6 rounded-xl shadow bg-white'>
            <h2 className='text-xl font-bold mb-6'>Restaurant Food Types Configuration</h2>

            <p className='text-sm text-gray-600 mb-4'>Configure food categories (Max 5 types)</p>

            {/* Food Type List */}
            <div className='flex flex-wrap gap-2 mb-4'>
              {foodTypes.map((type, index) => (
                <div key={index} className='flex items-center gap-2 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm'>
                  <span>{type}</span>
                  <button onClick={() => removeFoodType(type)} className='text-red-600 hover:text-red-800 font-bold text-lg'>
                    ×
                  </button>
                </div>
              ))}
            </div>

            {/* Add & Save */}
            {foodTypes.length < 5 && (
              <div className='flex gap-2 mb-4'>
                <input
                  type='text'
                  value={newType}
                  onChange={(e) => setNewType(e.target.value)}
                  placeholder='Enter food type (e.g., Vegan)'
                  className='border px-3 py-2 rounded-md text-sm flex-1 max-w-xs'
                  onKeyDown={(e) => e.key === "Enter" && handleAddAndSave()}
                />

                <button
                  onClick={handleAddAndSave}
                  disabled={!newType.trim()}
                  className={`px-4 py-2 rounded-md text-sm text-white ${
                    newType.trim() ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-300 cursor-not-allowed"
                  }`}
                >
                  Add & Save
                </button>
              </div>
            )}

            {foodTypes.length >= 5 && <p className='text-xs text-red-500 mb-4'>Maximum 5 food types allowed</p>}

            <p className='text-xs text-gray-500 mb-4'>Default types: {DEFAULT_FOOD_TYPES.join(", ")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FoodTypesTab;
